export interface BridgeHeaderRow {
	isBridgeHeader: true;
	toothNumberLabel: string | number;
	bridgeIndex: number;
	isCollapsed: boolean;
}

export interface ToothRow {
	isBridgeHeader: false;
	toothNumberLabel: string | number;
	treatment?: string;
	specification?: string;
	material?: string;
	shadeBody?: string;
	bridgeIndex?: number;
	ponticDesignId?: number;
}

export type TreatmentTableRow = BridgeHeaderRow | ToothRow;

export const isBridgeHeaderRow = (row: TreatmentTableRow): row is BridgeHeaderRow => {
	return row.isBridgeHeader === true;
};

export const isToothRow = (row: TreatmentTableRow): row is ToothRow => {
	return row.isBridgeHeader === false;
};
